<template>
    <div class="pp-ticket-check-results-detail">
        <div class="bs-container">
            <div v-for="drawResults in ticketCheckResult.drawsResults" :key="drawResults.drawId" class="bs-row">
                <div class="c-12 bs-offset-md-1 c-md-10">
                    <h3 class="pp-ticket-check-results-detail__heading">Vaše uhodnutá čísla</h3>
                    <PpTicketCheckResultsRychla6Table
                        v-if="config.lottery === Lottery.rychla6"
                        :lottery="Lottery.rychla6"
                        :results="drawResults.boards"
                    />
                    <PpTicketCheckResultsStastneDatumTable
                        v-else-if="config.lottery === Lottery.stastneDatum"
                        :results="drawResults.boards"
                    />
                    <PpTicketCheckResultsMainGameTable v-else :lottery="config.lottery" :results="drawResults.boards" />
                    <p class="pp-ticket-check-results-detail__text">Uvedené informace jsou bez záruky.</p>

                    <template v-if="isAddonPlayed">
                        <h3 class="pp-ticket-check-results-detail__heading">
                            Vaše uhodnutá čísla a výhry {{ lotteryAddonDisplayName }}
                        </h3>
                        <PpTicketCheckResultsAddonTable :results="drawResults.addon" />
                        <p class="pp-ticket-check-results-detail__text">Uvedené informace jsou bez záruky.</p>
                    </template>

                    <h3
                        class="pp-ticket-check-results-detail__heading pp-ticket-check-results-detail__heading--with-top-floor"
                    >
                        Podrobné výsledky
                    </h3>
                    <PpTicketCheckResultsDrawDetail :lottery="config.lottery" :draw-id="drawResults.drawId" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import { usePpTicketCheck } from "../../composables/use-ticket-check";
import PpTicketCheckResultsMainGameTable from "./pp-ticket-check-results-main-game-table.vue";
import { LotteryParser } from "@sazka/lotteries/js/utils/lottery-parser";
import PpTicketCheckResultsAddonTable from "./pp-ticket-check-results-addon-table.vue";
import { usePpWagerConfiguration } from "../../composables/use-wager-configuration";
import PpTicketCheckResultsDrawDetail from "./pp-ticket-check-results-draw-detail.vue";
import PpTicketCheckResultsRychla6Table from "./pp-ticket-check-results-rychla-6-table.vue";
import PpTicketCheckResultsStastneDatumTable from "./pp-ticket-check-results-stastne-datum-table.vue";
import { Lottery } from "@sazka/lotteries/js/models/lottery";

const { ticketCheckResult } = usePpTicketCheck();

const { config } = usePpWagerConfiguration();
const isAddonPlayed = !!ticketCheckResult.value.drawsResults[0].addon;
const lotteryAddonDisplayName = computed(() => LotteryParser.addonDisplayName(config.lottery));
</script>
